import { SelectOption } from '@/components/ui/select'

export const RETURNED_LABELS = {
  all: 'Todos',
  true: 'Sí',
  false: 'No',
}

export const returnedOptions: SelectOption[] = [
  { value: 'all', label: RETURNED_LABELS['all'] },
  { value: 'true', label: RETURNED_LABELS['true'] },
  { value: 'false', label: RETURNED_LABELS['false'] },
]
